import _LinkedPagination from './LinkedPagination'
import _Pagination from './Pagination'
import { withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'molecules-Pagination': {
      BFSG_previous_page: void
      BFSG_next_page: void
      BFSG_to_page_number: { PAGE_NUMBER: number }
      BFSG_to_linked_page: { PAGE_NAME: string }
    }
  }
}

const createWithTranslations = (Component) => {
  return withTranslations(Component, () =>
    useStaticQuery(graphql`
      query molecules_Pagination_translations {
        BFSG_previous_page: snippet(
          group: "molecules-Pagination"
          name: "BFSG_previous_page"
        )
        BFSG_next_page: snippet(
          group: "molecules-Pagination"
          name: "BFSG_next_page"
        )
        BFSG_to_page_number: snippet(
          group: "molecules-Pagination"
          name: "BFSG_to_page_number"
        )
        BFSG_to_linked_page: snippet(
          group: "molecules-Pagination"
          name: "BFSG_to_linked_page"
        )
      }
    `)
  )
}

export default createWithTranslations(_Pagination)
export const LinkedPagination = createWithTranslations(_LinkedPagination)
